export default __webpack_public_path__ + "static/forms_compare_comp1_active-c9fefefb83f1720b8e79bdfcaef4444a.png";